import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { ITheme } from '../features';

export const useTheme = <T = ITheme>(): T => useContext(ThemeContext);
